import create from "zustand";
import { persist } from "zustand/middleware";

type SideMenuState = {
  showSideMenu: boolean;
  toggleSideMenu: () => void;
};

const useSideMenu = create<SideMenuState>(
  persist(
    (set, getState) => ({
      showSideMenu: true,
      toggleSideMenu: () =>
        set((state) => ({ showSideMenu: !state.showSideMenu }))
    }),
    {
      name: "side_menu",
      version: 2
    }
  )
);

export default useSideMenu;
